// Types

export const VTabsSymbol = Symbol.for('vuetify:v-tabs');
//# sourceMappingURL=shared.mjs.map